<template>
    <v-container pa-0 class="align-self-end">
        <v-card class="pa-2"
                flat
                tile>
            <h2 class="headline font-weight-bold mb-3">
                {{ $vuetify.lang.t('$vuetify.page_not_found.page_title') }}
            </h2>
            <p class="body-1">
                {{ $vuetify.lang.t('$vuetify.page_not_found.page_description') }}
            </p>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'page-not-found',
    }
</script>
